import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';

type ToastBarContainerProps = {};

export function Toast(_props: ToastBarContainerProps) {
  return (
    <StyledToastContainer
      pauseOnFocusLoss={false}
      pauseOnHover={false}
      position={toast.POSITION.TOP_CENTER}
      theme='light'
    />
  );
}

const StyledToastContainer = styled(ToastContainer)`
  top: 65px;
  font-size: 16px;
  z-index: 9999;

  @media (max-width: 800px) {
  }
`;
